export default __webpack_public_path__ + "static/media/catalog.af7c35ba.pdf";